import { graphql } from 'gatsby';
import React, { Children, useState } from 'react';
import './infoBox.scss';
import parse from 'html-react-parser';
import CollapsibleBox from 'blocks/collapsableBox/collapsableBox';
import { ImgProps } from 'components/img/img';
import classNames from 'classnames';

interface Props {
  headline: string;
  text?: string;
  image?: ImgProps;
}

const InfoBox: React.FC<Props> = (props) => {
  // console.log(props.image?.localFile?.publicURL);
  const image = props.image?.localFile?.publicURL;
  return (
    <div className="info-box">
      <div className="wrapper">
        <div className="info-box__inner">
          <CollapsibleBox headline={props.headline}>
            <div className="info-box__collapsable">
              <div className="info-box__text">{!!props.text && parse(props.text)}</div>
              {!!image && <div className="info-box__image"><img alt="" src={image} /></div>}
            </div>
          </CollapsibleBox>
        </div>
      </div>
    </div>
  );
};

export default InfoBox;

export const query = graphql`
  fragment InfoBoxBlock on WpAcfInfoboxBlock {
    AcfInfoBlock {
      headline
      text
      image {
        ...FeaturedImage
      }
    }
  }
`;
